import { render, staticRenderFns } from "./UnknownItem.vue?vue&type=template&id=f88cd832&"
import script from "./UnknownItem.vue?vue&type=script&lang=js&"
export * from "./UnknownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports